
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"21","viewBox":"0 0 27.384 36.082"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 5782"}},[_c('path',{attrs:{"data-name":"Unión 281","d":"M.649 36.082a.65.65 0 01-.65-.65V.65A.65.65 0 01.649 0h16.482a.65.65 0 01.455.185l9.6 9.388a.65.65 0 01.2.465v25.394a.649.649 0 01-.65.65zm.65-1.3h24.78V10.723h-8.964a.65.65 0 01-.65-.65V1.3H1.299zM17.768 9.423h7.373l-7.373-7.226z"}}),_c('g',{attrs:{"data-name":"Grupo 5781"}},[_c('path',{attrs:{"data-name":"Trazado 64","d":"M5.589 29.979z"}}),_c('path',{attrs:{"data-name":"Trazado 64 - Contorno","d":"M5.589 29.329h16.2a.65.65 0 010 1.3h-16.2a.65.65 0 010-1.3z"}}),_c('path',{attrs:{"data-name":"Trazado 65","d":"M5.589 24.013z"}}),_c('path',{attrs:{"data-name":"Trazado 65 - Contorno","d":"M5.589 23.363h16.2a.65.65 0 010 1.3h-16.2a.65.65 0 010-1.3z"}}),_c('path',{attrs:{"data-name":"Trazado 66","d":"M5.589 18.047z"}}),_c('path',{attrs:{"data-name":"Trazado 66 - Contorno","d":"M5.589 17.397h16.2a.65.65 0 010 1.3h-16.2a.65.65 0 010-1.3z"}})])])])
          )
        }
      }
    